'use client';

import React, { useState } from 'react';
import { Icon } from '@/src/components/ui';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@workspace/ui/components/dropdown-menu';
import { cn } from '@workspace/ui/lib/utils';
import { StarRating } from './StarRating';
import { StarValue } from 'types/src/types';

export type StarsOption = StarValue | 'all';

interface Props {
  onFilterChange?: (rating: StarsOption) => void;
}

export const ReviewsFilter = ({ onFilterChange }: Props) => {
  const [isOpen, setIsOpen] = useState(true);
  const [selectedRating, setSelectedRating] = useState<StarsOption>('all');

  const handleRatingClick = (rating: StarsOption) => {
    setSelectedRating(rating);
    onFilterChange?.(rating);
  };

  const filterOptions: {
    rating: StarsOption;
    button: string;
    label?: string;
  }[] = [
    { rating: 'all', button: 'All reviews', label: 'All reviews' },
    { rating: 1, button: 'View', label: '1 star reviews' },
    { rating: 2, button: 'View', label: '2 star reviews' },
    { rating: 3, button: 'View', label: '3 star reviews' },
    { rating: 4, button: 'View', label: '4 star reviews' },
    { rating: 5, button: 'View', label: '5 star reviews' },
  ];

  return (
    <DropdownMenu onOpenChange={setIsOpen}>
      <DropdownMenuTrigger className="flex items-center gap-1 w-min-fit">
        <div className="h-7 rounded md:text-sm text-[10px] font-normal px-3 py-1.5 flex items-center gap-1 hover:cursor-pointer bg-transparent">
          {selectedRating
            ? filterOptions.find((option) => option.rating === selectedRating)
                ?.label
            : 'All reviews'}
          <Icon
            name="chevron-down"
            className={cn('size-3', {
              'rotate-180': isOpen,
            })}
          />
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        {filterOptions.map(({ rating, button }) => (
          <DropdownMenuItem
            key={rating}
            onClick={() => handleRatingClick(rating)}
            className="hover:cursor-pointer md:text-sm text-[10px] flex items-center gap-2"
          >
            <StarRating rating={rating === 'all' ? null : rating} />
            {rating !== 'all' && button}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
